<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="scheduleDetails">
          <div class="mb-3 w-100">
            <h1 class="mb-2">
              جلسه {{ scheduleDetails.lessonTitle }} با زبان آموز
              {{ scheduleDetails.studentFullName }}
            </h1>
            <h4 class="my-1">
              گروه‌بندی: {{ scheduleDetails.priceCategoryTitle }}
            </h4>
            <div
              class="w-100 d-flex flex-md-row flex-column align-items-center justify-content-between"
            >
              <p class="mb-2">
                زمان شروع:
                {{
                  new Date(`${scheduleDetails.startDate}`).toLocaleDateString(
                    "fa-IR"
                  )
                }}
                ساعت:
                {{
                  new Date(`${scheduleDetails.startDate}`).toLocaleTimeString(
                    "fa-IR",
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )
                }}
                - مدت جلسه: {{ scheduleDetails.priceCategoryDuration }} دقیقه
              </p>
              <div class="d-flex flex-column align-items-center">
                <b-link
                  :to="`/master/reserved/${$route.params.id}/exam-create`"
                  v-if="!scheduleDetails.examId && scheduleDetails.lessonId"
                  class="btn btn-success"
                >
                  آماده سازی آزمون جلسه
                </b-link>
                <!-- <b-link
                  :to="`/master/reserved/${$route.params.id}/report`"
                  v-if="!scheduleDetails.examId"
                  class="btn btn-info mt-1"
                >
                  مشاهده سوابق زبان آموز
                </b-link> -->
              </div>
            </div>
            <div
              class="d-flex align-items-center mt-1"
              style="font-size: 1.5rem"
            >
              <span class="mr-1">شماره همراه:</span>
              <a :href="`tel:${scheduleDetails.studentMobile}`">{{
                scheduleDetails.studentMobile
              }}</a>
            </div>
          </div>
          <!-- <div
            class="w-100 mt-3 d-flex align-items-center justify-content-center"
          >
            <b-button
              @click="startScheduleExam"
              variant="success"
              v-if="
                scheduleDetails.status == 1 ||
                (!scheduleDetails.lessonId &&
                  scheduleDetails.status != 7 &&
                  scheduleDetails.status != 4)
              "
            >
              شروع جلسه
            </b-button>
            <b-button
              @click="updateExamStatusForIndependentLessons(4)"
              variant="danger"
              v-if="scheduleDetails.status == 7"
            >
              اتمام جلسه بدون قبولی
            </b-button>
            <b-button
              class="ml-1"
              @click="updateExamStatusForIndependentLessons(5)"
              variant="success"
              v-if="scheduleDetails.status == 7"
            >
              اتمام جلسه با قبولی
            </b-button>
          </div> -->
          <div
            v-if="
              scheduleDetails.examId &&
              scheduleDetails.status == 7 &&
              scheduleDetails.result == null &&
              !isGettingScoresFromMaster
            "
          >
            <take-an-special-exam
              :examId="scheduleDetails.examId"
              @getScheduleScores="getASingleSchedule"
            ></take-an-special-exam>
          </div>
          <div
            v-else-if="
              scheduleDetails.examId &&
              scheduleDetails.status == 7 &&
              scheduleDetails.result != null &&
              isGettingScoresFromMaster
            "
          >
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group label="نمره گرامر" label-for="grammerScore">
                  <b-form-input
                    v-model="scheduleDetails.grammerScore"
                    id="grammerScore"
                    trim
                    placeholder="نمره گرامر"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="نمره شنیداری" label-for="listeningScore">
                  <b-form-input
                    v-model="scheduleDetails.listeningScore"
                    id="listeningScore"
                    trim
                    placeholder="نمره Listening"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="نمره تلفظ" label-for="pronunciationScore">
                  <b-form-input
                    v-model="scheduleDetails.pronunciationScore"
                    id="pronunciationScore"
                    trim
                    placeholder="نمره Pronunciation"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="نمره سرعت" label-for="speedScore">
                  <b-form-input
                    v-model="scheduleDetails.speedScore"
                    id="speedScore"
                    trim
                    placeholder="نمره Speed"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="نمره دایره کلمات" label-for="vocabScore">
                  <b-form-input
                    v-model="scheduleDetails.vocabScore"
                    id="vocabScore"
                    trim
                    placeholder="نمره Vocabulary"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="نمره لحجه" label-for="accentScore">
                  <b-form-input
                    v-model="scheduleDetails.accentScore"
                    id="accentScore"
                    trim
                    placeholder="نمره Accent"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <div
                  class="w-100 d-flex align-items-center justify-content-end"
                >
                  <b-button variant="success" @click="setScheduleScores">
                    ثبت نمره
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <div
            v-if="
              scheduleDetails.status == 5 ||
              scheduleDetails.status == 6 ||
              scheduleDetails.status == 4
            "
          >
            <p>این جلسه به اتمام رسیده است</p>
            <div class="d-flex align-items-center justify-content-between">
              <b-link to="/master/reserved/" class="btn btn-success">
                بازگشت
              </b-link>
              <button
                v-if="scheduleDetails.status != 4"
                class="btn btn-success"
                v-b-modal.modal-graduate
              >
                فارغ‌التحصیلی
              </button>
            </div>
            <hr
              class="my-3"
              v-if="scheduleDetails.status != 4 && !scheduleDetails.lessonId"
            />
            <b-row
              v-if="scheduleDetails.status != 4 && !scheduleDetails.lessonId"
            >
              <b-col cols="12" md="6">
                نمره گرامر:‌{{ scheduleDetails.grammerScore }}
              </b-col>
              <b-col cols="12" md="6">
                نمره شنیدن:‌{{ scheduleDetails.listeningScore }}
              </b-col>
              <b-col cols="12" md="6">
                نمره تلفظ:‌{{ scheduleDetails.pronunciationScore }}
              </b-col>
              <b-col cols="12" md="6">
                نمره سرعت:‌{{ scheduleDetails.speedScore }}
              </b-col>
              <b-col cols="12" md="6">
                نمره دایره کلمات:‌{{ scheduleDetails.vocabScore }}
              </b-col>
              <b-col cols="12" md="6">
                نمره دایره لحجه:‌{{ scheduleDetails.accentScore }}
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col cols="12">
              <hr />
              <user-bought-lesson-list
                :userIdFilter="scheduleDetails.studentUserId"
                :userFullName="scheduleDetails.studentFullName"
              ></user-bought-lesson-list>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <hr />
              <student-schedule-history
                :userFullName="scheduleDetails.studentFullName"
                :userIdFilter="scheduleDetails.studentUserId"
                :priceCategoryId="scheduleDetails.priceCateogryId"
              ></student-schedule-history>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      title="فارغ‌التحصیلی زبان آموز"
      id="modal-graduate"
      centered
      ok-title="بله"
      cancel-title="خیر"
      @ok="graduateStudentFromRoadmapGroup"
    >
      <b-container fluid>
        <p>آیا از فارغ‌التحصیلی این زبان آموز اطمینان دارید؟</p>
      </b-container>
    </b-modal>
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getASingleSchedule();
  },
  data() {
    return {
      scheduleDetails: null,
      isLoading: false,
      isGettingScoresFromMaster: false,
      examDetails: null,
      examStatusToScheduleStatus: {
        2: 5,
        3: 6,
      },
    };
  },
  methods: {
    async updateExamStatusForIndependentLessons(status) {
      try {
        this.isLoading = true;
        let _this = this;
        let updateScheduleStatus = new UpdateScheduleStatus(_this);
        updateScheduleStatus.setRequestParam({
          id: _this.$route.params.id,
          status: status, // is for done
        });
        await updateScheduleStatus.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "پایان یافت!",
                icon: "CheckIcon",
                variant: "success",
                text: "جلسه با موفقیت پایان یافت.",
              },
            });
            _this.getASingleSchedule();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async graduateStudentFromRoadmapGroup() {
      try {
        this.isLoading = true;
        let _this = this;
        let graduateUserFromRoadmap = new GraduateUserFromRoadmap(_this);
        graduateUserFromRoadmap.setRequestParam({
          groupId: _this.scheduleDetails.roadMapGroupId,
        });
        await graduateUserFromRoadmap.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ثبت شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "زبان آموز فارغ‌التحصیل شد.",
              },
            });
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async setScheduleScores() {
      await this.getAnExam();
      if (this.examStatusToScheduleStatus[this.examDetails.status]) {
        this.scheduleDetails.status =
          this.examStatusToScheduleStatus[this.examDetails.status];
      }
      this.updateASingleSchedule();
    },
    async getAnExam() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleExam = new GetASingleExam(_this);
        getASingleExam.setRequestParam({ id: _this.scheduleDetails.examId });
        await getASingleExam.fetch((response) => {
          if (response.isSuccess) {
            _this.examDetails = response.data;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getScheduleScoresFromMaster() {
      this.isGettingScoresFromMaster = true;
    },
    async startScheduleExam() {
      this.scheduleDetails.status = 7;
      await this.updateASingleSchedule();
    },
    async updateASingleSchedule() {
      try {
        this.isLoading = true;
        let _this = this;
        let updateAScheduleForMaster = new UpdateAScheduleForMaster(_this);
        updateAScheduleForMaster.setRequestParamDataObj(_this.scheduleDetails);
        await updateAScheduleForMaster.fetch((response) => {
          if (response.isSuccess) {
            _this.getASingleSchedule();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getASingleSchedule() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleScheduleForMaster = new GetASingleScheduleForMaster(
          _this
        );
        getASingleScheduleForMaster.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASingleScheduleForMaster.fetch((response) => {
          if (response.isSuccess) {
            _this.scheduleDetails = response.data;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
        if (
          this.scheduleDetails.examId &&
          this.scheduleDetails.status == 7 &&
          this.scheduleDetails.result != null &&
          this.scheduleDetails.listeningScore == 0 &&
          this.scheduleDetails.speedScore == 0 &&
          this.scheduleDetails.vocabScore == 0 &&
          this.scheduleDetails.grammerScore == 0 &&
          this.scheduleDetails.pronunciationScore == 0 &&
          this.scheduleDetails.accentScore == 0
        ) {
          this.getScheduleScoresFromMaster();
        }
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BLink,
    BOverlay,
    BContainer,
    TakeAnSpecialExam,
    UserBoughtLessonList,
    StudentScheduleHistory,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BModal,
  BLink,
  BOverlay,
  BContainer,
} from "bootstrap-vue";
import {
  GetASingleScheduleForMaster,
  UpdateAScheduleForMaster,
  UpdateScheduleStatus,
} from "@/libs/Api/Schedules";
import { GetASingleExam } from "@/libs/Api/Exam";
import { GraduateUserFromRoadmap } from "@/libs/Api/RoadmapGroup";
import TakeAnSpecialExam from "@/views/components/Exams/TakeAnSpecialExam.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import UserBoughtLessonList from "@/views/components/UserBoughtLessons/UserBoughtLessonList.vue";
import StudentScheduleHistory from "@/views/apps/MasterSchedule/StudentScheduleHistory.vue";
</script>
